export const RECEIVE_ACTIVITY = 'RECEIVE_ACTIVITY'
export const RECEIVE_COMPETENCY = 'RECEIVE_COMPETENCY'
export const RECEIVE_ANSWER = 'RECEIVE_ANSWER'


function receiveActivity(activityId,activity) {
  return {
    type: RECEIVE_ACTIVITY,
    activityId,
    activity,
    receivedAt: Date.now()
  }
}

function receiveCp(activityId,competencyId,competency) {
  return {
    type: RECEIVE_COMPETENCY,
    activityId,
    competencyId,
    competency,
    receivedAt: Date.now()
  }
}

function receiveAnswer(competencyId,dimensionId,answer) {
  return  {
    type: RECEIVE_ANSWER,
    competencyId,
    dimensionId,
    answer
  }
}

export function fetchActivities(assessmentId,firestore) {
  return dispatch => {
    const assessmentRef = firestore.collection('assessmentsByRater').doc(assessmentId)

    return assessmentRef.get()
      .then(assessment => { 
          const assessmentData = assessment.data()
          return assessmentData })
      .then(data => data && data.activities 
        ? data.activities.map(activity => 
          activity.get().then(act => {
            const actData = act.data() 
            

            actData && actData.competencies 
              ? actData.competencies.map( (competency,sort) =>
                competency.get().then(cp => {
                    const cpData = cp.data()
                    

                    dispatch(receiveCp(act.id,cp.id, cpData))

                      assessmentRef.collection('answers')
                      .doc(act.id).collection('competencies')
                      .doc(cp.id).collection('dimensions')
                      .get().then(snapshot => 
                        snapshot.docs.forEach(dimension => 
                            {
                              const answer = dimension.data()

                              dispatch(receiveAnswer(cp.id,dimension.id,answer)) 
                            }
                          ) 
                        )

                    return cpData              
                  }
                )
              )
              : []

            dispatch(receiveActivity(act.id, actData ))
            return actData
            }  ) )
        : [])
  }
}



// WEBPACK FOOTER //
// ./src/modules/competencies/actions.js